import { render, staticRenderFns } from "./CompanyRegistrationForm.vue?vue&type=template&id=e15823ea&"
import script from "./CompanyRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./CompanyRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports